import React from 'react';
import { motion } from 'framer-motion';

const DriftUIShowcase: React.FC = () => {
  const fadeInUp = {
    hidden:  { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] as const } },
  };

  return (
    <motion.section
      className="drift-section drift-ui-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-80px' }}
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.15 } } }}
    >
      <div className="drift-container" style={{ textAlign: 'center' }}>
        <motion.p className="drift-section-label" variants={fadeInUp}>07 — The App</motion.p>
        <motion.h2 className="drift-section-title" variants={fadeInUp}>drift in motion.</motion.h2>
      </div>

      <motion.div className="drift-ui-frame-wrap" variants={fadeInUp}>
        <iframe
          src="/content/Drift/Drift new/dist/index.html"
          title="Drift App"
          className="drift-ui-iframe"
        />
      </motion.div>

      <div className="drift-ui-cta">
        <a
          href="https://letsdrift.figma.site/"
          target="_blank"
          rel="noopener noreferrer"
          className="drift-ui-cta-btn"
        >
          Experience drift fully
          <span className="drift-ui-cta-arrow">↗</span>
        </a>
      </div>
    </motion.section>
  );
};

export default DriftUIShowcase;
